import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseSection from './components/WhyChooseSection';
import NJInfoSection from './components/NJInfoSection';
import TestimonialsSection from './components/TestimonialsSection';
import Footer from './components/Footer';
import HomeSchemaLD from '../../components/feature/HomeSchemaLD';

export default function HomePage() {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <Header />
      <main>
        <HomeSchemaLD />
        <Hero />
        <AboutSection />
        <ServicesSection />
        <WhyChooseSection />
        <NJInfoSection />
        <TestimonialsSection />
      </main>
      <Footer />
    </div>
  );
}
